module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASAgMAAADwG8zmAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAf4C/aSLHAAAAMklEQVQI12OAgAYGBsYDDAzsQCwPxPUHGBj/H2BgB2J5EAazQWIgOZAasFqIHgYHkAEAosQS1SrU7PgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/stats/arrow_left.png
// module id = 677
// module chunks = 3